import { render, staticRenderFns } from "./JobProductAmounts.vue?vue&type=template&id=0e648bca&scoped=true"
import script from "./JobProductAmounts.vue?vue&type=script&lang=js"
export * from "./JobProductAmounts.vue?vue&type=script&lang=js"
import style0 from "./JobProductAmounts.vue?vue&type=style&index=0&id=0e648bca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e648bca",
  null
  
)

export default component.exports